module.exports = __webpack_public_path__ + "assets/img/l4.5672fd98.png";